<template>
  <div id="echartsChina">
  </div>
</template>

<script>
import resize from './mixins/resize'
import * as echarts from 'echarts'
import china from '@/assets/map/json/china.json'
import common from '@/mixins/common.js'

export default {
  mixins: [resize, common],
  name: 'EchartsChina',
  components: {
  },
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    },
    'chinaTitleac': {
      type: [String, Number],
      default: 0
    },
    visualMapColor: {
      type: Array,
      default: () => { return ['green', 'yellow', 'red'] }
    }
  },
  data () {
    let thatV = this
    return {
      chart: null,
      // echart 配制option
      options: {
        tooltip: {
          triggerOn: 'mousemove', // mousemove、click
          padding: 8,
          borderWidth: 1,
          borderColor: '#409eff',
          backgroundColor: 'rgba(255,255,255,0.7)',
          textStyle: {
            color: '#000000',
            fontSize: 13
          },
          formatter: function (e, t, n) {
            let data = e.data
            let context
            if (data) {
              context = `
             <div>
                  <p>${data.name}</p>
                  <p>${thatV.numberSplitWithComma(data.value)}</p>
             </div>
             `
            }
            return context
          }
        },
        visualMap: {
          show: false,
          min: 0,
          max: 100000000,
          text: ['High', 'Low'],
          realtime: false,
          calculable: true,
          inRange: {
            color: thatV.visualMapColor ?? ['green', 'yellow', 'red']
          },
          bottom: 0,
          textStyle: {
            color: '#fff'
          },
          formatter (e) {
            return `${thatV.numberSplitWithComma(e)}`
          }
        },
        geo: {
          map: 'china',
          center: [104.97, 39.71],
          // center: ['50%', '50%'],
          // scaleLimit: {
          //   min: 1,
          //   max: 2
          // },
          zoom: 1.2,
          top: 0,
          label: {
            normal: {
              show: true,
              fontSize: '11',
              color: '#fff',
              formatter: function (e) {
                let item = thatV.options.series[0].data.find(item => item.name === e.name)
                if (item) {
                  let allrevenueVal = item.value
                  if (thatV.chinaTitleac === 1) {
                    allrevenueVal = parseInt(allrevenueVal / 1000)
                  } else {
                    allrevenueVal = parseInt(allrevenueVal / 10000)
                  }
                  return `${item.name}\n${allrevenueVal}`
                }
                return e.name
              }
            }

          },
          itemStyle: {
            normal: {
              // shadowBlur: 50,
              // shadowColor: 'rgba(0, 0, 0, 0.2)',
              borderColor: 'rgba(0, 0, 0, 0.2)'

            },
            emphasis: {
              areaColor: '#f2d5ad',
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0
            }
          }
        },
        series: [
          {
            type: 'map',
            geoIndex: 0,
            data: []
          }
        ]
      },
      // echart data
      dataList: [

      ]
    }
  },
  computed: {

  },
  created () {
  },
  mounted () {
    this.$nextTick(() => {
      this.initEchartMap()
    })
  },
  watch: {
    'data': {
      handler: function (newValue, oldValue) {
        this.handleChinaEchart(newValue)
      },
      immediate: true,
      deep: true
    },
    'chinaTitleac': {
      handler: function (newValue) {
        let type = newValue ? 'deficiencyMapList' : 'terminalMapList'
        this.handleChinaEchart(this.data, type)
      },
      immediate: true,
      deep: true
    },
    chartDefaults: {
      default: () => { return {} },
      type: Object
    }
  },
  methods: {
    // 初始化中国地图
    initEchartMap () {
      let mapDiv = document.getElementById('echartsChina')
      echarts.registerMap('china', { geoJSON: china })
      this.chart = echarts.init(mapDiv, {}, { renderer: 'svg' })
      this.chart.on('click', this.echartsMapClick)
      this.handleChinaEchart(this.data)
      // echarts.registerMap('js1', china)
      // echarts.registerMap('安徽', anhui)
      // this.chart.setOption(this.options)
    },
    // 修改echart配制
    setEchartOption () {
      this.options.series[0]['data'] = []
      this.dataList.forEach(item => {
        this.options.series[0]['data'].push(item)
      })
    },
    // 地图点击
    echartsMapClick (params) {
      // this.areaName = params.areaName
      // if (params.name in this.provincesMap) {
      //   this.areaCode = params.data.areaCode
      //   this.areaLevel = params.data.areaLevel
      //   // 如果点击的是34个省、市、自治区，绘制选中地区的二级地图
      //   this.requestGetProvinceJSON(params.data)
      // } else if (params.seriesName in this.provincesMap) {
      //   // 如果是【直辖市/特别行政区】只有二级下钻
      //   if (this.special.indexOf(params.seriesName) >= 0) {
      //     return
      //   } else {
      //     this.areaCode = this.areaMap[params.name]
      //     this.areaLevel = params.data.areaLevel
      //     // 显示县级地图
      //     this.requestGetCityJSON(params.data)
      //   }
      // } else {
      //   return
      // }
      // this.$emit('map-change', params.data)
    },
    setChartInit () {
      this.chart && this.chart.setOption(this.options)
    },
    handleChinaEchart (value, type = 'terminalMapList') {
      let maxValArr = []
      let deficiencyMapList = value[type]
      if (!deficiencyMapList || deficiencyMapList.length === 0) { return }
      this.dataList = []
      deficiencyMapList.forEach(item => {
        let value = isNaN(item.allrevenue) ? (item.value || 0) : item.allrevenue
        let name = (item.province || item.name || '').replace(/['省','市'，'回族自治区','自治区','壮族','特别行政区','维吾尔自治区']/g, '')
        this.dataList.push({
          name: name,
          value: value
        })
        maxValArr.push(value)
      })
      this.options.visualMap.max = this.setVisuMax(maxValArr)
      this.setEchartOption()
      this.chart && this.chart.setOption(this.options)
    },
    setVisuMax (val) {
      let max = Math.max(...val)
      let endVal = 1
      while (endVal < max) {
        endVal *= 10
      }
      endVal = (parseInt(max / endVal * 10) + 1) * endVal / 10
      return endVal
    }
  }

}
</script>

<style scoped lang="stylus">
</style>
